import { createSelector } from 'reselect'
import { AppGlobalState, Progress } from '../../types'
import { InventoryItem } from './types'
import { EntityMetadata } from 'modules/domain/types'

const dict = (state: AppGlobalState) => state.inventoryExchange.items
const ids = (state: AppGlobalState) => state.inventoryExchange.ids
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const item = (state: AppGlobalState, id: string): InventoryItem | undefined => state.inventoryExchange.items[id]
const meta = (state: AppGlobalState, id: string): EntityMetadata<InventoryItem> =>
  state.inventoryExchange.meta[id] || {
    fetchError: null,
    fetchProgress: Progress.IDLE,
    id,
    removeError: null,
    removeProgress: Progress.IDLE,
    updateError: null,
    updateProgress: Progress.IDLE,
  }
const itemFetchProgress = (state: AppGlobalState) => state.inventoryExchange.itemFetchProgress
const listFetchProgress = (state: AppGlobalState) => state.inventoryExchange.listFetchProgress
const listFetchError = (state: AppGlobalState) => state.inventoryExchange.listFetchError
const listFetchErrorDetail = (state: AppGlobalState) => state.inventoryExchange.listFetchErrorDetail
const listFetchNextProgress = (state: AppGlobalState) => state.inventoryExchange.listFetchNextProgress
const listFetchNextError = (state: AppGlobalState) => state.inventoryExchange.listFetchNextError
const listFetchNextErrorDetail = (state: AppGlobalState) => state.inventoryExchange.listFetchNextErrorDetail
const deliveryOptionProgress = (state: AppGlobalState) => state.inventoryExchange.deliveryOptionProgress
const priceUpdateProgress = (state: AppGlobalState) => state.inventoryExchange.priceUpdateProgress
const list = createSelector(dict, ids, listFetchProgress, (dict, ids, progress) => {
  if (progress === Progress.WORK) {
    return []
  }
  const result: InventoryItem[] = []
  for (const id of ids) {
    result.push(dict[id])
  }
  return result
})

const filter = (state: AppGlobalState) => state.inventoryExchange.filter
const sorting = (state: AppGlobalState) => state.inventoryExchange.sorting
const page = (state: AppGlobalState) => state.inventoryExchange.page
const total = (state: AppGlobalState) => state.inventoryExchange.total
const updateProgress = (state: AppGlobalState) => state.inventoryExchange.updateProgress
const removeProgress = (state: AppGlobalState) => state.inventoryExchange.removeProgress
const addProgress = (state: AppGlobalState) => state.inventoryExchange.addProgress
const transferProgress = (state: AppGlobalState) => state.inventoryExchange.transferProgress
const hasNext = (state: AppGlobalState) => state.inventoryExchange.total > state.inventoryExchange.ids.length
const pageSize = (state: AppGlobalState) => state.inventoryExchange.pageSize
const pages = (state: AppGlobalState) => Math.ceil(state.inventoryExchange.total / state.inventoryExchange.pageSize)

const InventoryExchangeSelectors = {
  filter,
  sorting,
  page,
  total,
  updateProgress,
  removeProgress,
  addProgress,
  transferProgress,
  item,
  meta,
  itemFetchProgress,
  listFetchProgress,
  listFetchError,
  listFetchErrorDetail,
  list,
  dict,
  ids,
  hasNext,
  pageSize,
  listFetchNextProgress,
  listFetchNextError,
  listFetchNextErrorDetail,
  pages,
  deliveryOptionProgress,
  priceUpdateProgress,
}

export default InventoryExchangeSelectors
